import Flex, {FlexChild} from "../../../styles/Flex";
import {Name} from "../../../styles/Details";
import {Logo, ModelLabel} from "../headerItems";
import theme from "../../../styles/theme";
import React from "react";

export const Header = (props) =>
    <Flex justifyContent={"flex-start"} alignItems={"center"}>
        <FlexChild>
            <Name>{props.name}</Name>
        </FlexChild>
        <FlexChild>
            <Logo
                shortName={props.originatorShortName}
                height={theme.grid.originatorLogoWidth}
                width={theme.grid.originatorLogoWidth}
                marginLeft={"10px"}
            />
        </FlexChild>
        <FlexChild>
            <ModelLabel
                modelName={props.modelName}
                marginLeft={"10px"}
            />
        </FlexChild>
        <FlexChild>
            <Name>{props.freeText}</Name>
        </FlexChild>
    </Flex>;



// WEBPACK FOOTER //
// ./src/components/results/details/Header.js